"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
class API {
    /**
     * Use this method for authenticated users to sign up for an promotion
     * @returns {Promise<any>} The Promise contains an APIError if rejected
     * Error Types:
     * 401 MissingAuthorizationError
     * 401 SessionNotFoundError
     * 402 PaymentInfoMissingError
     * 400 InvalidParametersError
     * 403 NotAccessibleError: Already subscribed to a plan
     * 404 ResourceNotFound: Promotioncode not found or expired
     * 500 InternalServerError
     */
    static applyPromotion(promotion_code, partner) {
        let apiRequest = new request_1.AuthenticatedRequest('/promotion/sign_up', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, {}, {
            promotion_code,
            partner
        });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
}
exports.API = API;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/endpoints/promotion.js
// module id = 962
// module chunks = 0